module.exports = __webpack_public_path__ + "img/5.a2c614d2.png";